<template>
  <div class="theme-test">
    <h3>Theme Colors Test</h3>
    <div v-if="userThemeColors" class="theme-info">
      <p><strong>Current Theme Colors:</strong></p>
      <ul>
        <li v-for="(color, key) in userThemeColors" :key="key">
          <span :style="{ backgroundColor: color, width: '20px', height: '20px', display: 'inline-block', marginRight: '10px' }"></span>
          {{ key }}: {{ color }}
        </li>
      </ul>
    </div>
    <div v-else class="no-theme">
      <p>No theme colors found in userData.themeColors</p>
    </div>
    <div class="theme-preview">
      <h4>Theme Preview:</h4>
      <div class="preview-sidebar" :style="{ backgroundColor: getThemeColor('sidebar_background_color', '#96b363') }">
        <p :style="{ color: getThemeColor('sidebar_text_color', 'white') }">Sidebar Background</p>
      </div>
      <div class="preview-header" :style="{ backgroundColor: getThemeColor('header_background_color', 'white') }">
        <p :style="{ color: getThemeColor('header_text_color', '#782b54') }">Header Background</p>
      </div>
      <div class="preview-button" :style="{
        backgroundColor: getThemeColor('button_background_color', 'white'),
        color: getThemeColor('button_text_color', 'black'),
        border: `1px solid ${getThemeColor('button_border_color', '#BDA340')}`,
        padding: '10px',
        borderRadius: '5px',
        display: 'inline-block'
      }">
        Button Preview
      </div>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/mixins/themeMixin.js'

export default {
  name: 'ThemeTest',
  mixins: [themeMixin]
}
</script>

<style scoped>
.theme-test {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin: 20px;
}

.theme-info ul {
  list-style: none;
  padding: 0;
}

.theme-info li {
  margin: 5px 0;
  display: flex;
  align-items: center;
}

.preview-sidebar,
.preview-header {
  padding: 15px;
  margin: 10px 0;
  border-radius: 5px;
}

.preview-button {
  margin: 10px 0;
}
</style>
